import { ComponentRef, Directive, ElementRef, HostListener, Input, OnDestroy, OnInit } from '@angular/core';
import { Card } from '@deckplan.io/common';
import { Overlay, OverlayPositionBuilder, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { CardImageComponent } from './card-image/card-image.component';

@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: '[cardImageTooltip]'
})
export class CardImageTooltipDirective implements OnInit, OnDestroy {

    @Input('cardImageTooltip') public card: Card;
    // eslint-disable-next-line no-magic-numbers
    @Input('cardImageTooltipWidth') public width = 250;

    private overlayRef: OverlayRef;
    private timeout;

    constructor(private readonly overlayPositionBuilder: OverlayPositionBuilder,
                private readonly elementRef: ElementRef,
                private readonly overlay: Overlay) {}

    public ngOnInit() {
        const positionStrategy = this.overlayPositionBuilder
            .flexibleConnectedTo(this.elementRef)
            .withPositions([
                {
                    originX: 'center',
                    originY: 'bottom',
                    overlayX: 'center',
                    overlayY: 'top',
                },
                {
                    originX: 'center',
                    originY: 'top',
                    overlayX: 'center',
                    overlayY: 'bottom'
                }
            ]
            );

        this.overlayRef = this.overlay.create({positionStrategy});
    }

    public ngOnDestroy() {
        this.hide();
    }

    @HostListener('mouseenter')
    public show() {
        if ((!(this.card as any).hasOwnProperty('images') && !(this.card as any).hasOwnProperty('cardFaces')) || this.timeout >= 0) {
            return;
        }

        this.timeout = setTimeout(this.doShow.bind(this), 500);
    }

    private doShow() {
        const tooltipPortal = new ComponentPortal(CardImageComponent);

        const tooltipRef: ComponentRef<CardImageComponent> = this.overlayRef.attach(tooltipPortal);

        tooltipRef.instance.card = this.card;
        tooltipRef.instance.width = this.width;
        tooltipRef.instance.hoverable = false;
        tooltipRef.instance.draggable = false;
        tooltipRef.instance.clickable = false;
    }

    @HostListener('mouseout')
    public hide() {
        clearTimeout(this.timeout);
        this.timeout = -1;
        if (this.overlayRef.hasAttached()) {
            this.overlayRef.detach();
        }
    }

}
